<template>
  <div class="detail-page">
    <div class="content">
      <h1>{{ $t('faq.title') }}</h1>
      <div class="divider"></div>
      <div class="faq-list">
        <div
          class="faq-item"
          v-for="(item, index) in faqs"
          :key="index"
          :class="{ open: item.open }"
          @click="toggle(index)"
        >
          <div class="faq-q">
            <span>{{ item.q }}</span>
            <span class="arrow">→</span>
          </div>
          <div class="faq-a" v-show="item.open">{{ item.a }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FaqDetail',
  data() {
    return {
      openMap: {}
    }
  },
  computed: {
    faqs() {
      return (this.$t('faq.list') || []).map(function(item, index) {
        var vm = this
        return { ...item, open: vm.openMap[index] || false }
      }.bind(this))
    }
  },
  methods: {
    toggle(index) {
      this.$set(this.openMap, index, !this.openMap[index])
    }
  }
}
</script>

<style scoped>
.detail-page { min-height: 100vh; background: #f7f8fc; padding-top: 24px; }
.content {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 40px 60px;
}
.divider {
  width: 48px;
  height: 3px;
  background: #2b7de9;
  margin: 16px 0 32px;
}
h1 { font-size: 28px; font-weight: 700; color: #1a1a1a; }
.faq-list { margin-top: 8px; }
.faq-item {
  background: #fff;
  border-radius: 8px;
  padding: 18px 24px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: box-shadow 0.2s;
}
.faq-item:hover { box-shadow: 0 2px 8px rgba(0,0,0,0.06); }
.faq-q {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
}
.arrow {
  font-size: 14px;
  color: #2b7de9;
  transition: transform 0.2s;
}
.open .arrow { transform: rotate(90deg); }
.faq-a {
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  margin-top: 12px;
}
@media (max-width: 768px) {
  .back-bar, .content { padding-left: 20px; padding-right: 20px; }
}
</style>
